import { connect } from 'react-redux';
import AuctionsList from 'components/auctions/AuctionsList';
import {
  fetchForSelectionAuctions,
  cancelAuctions,
  setAuctionsGridFilter,
  clearAuctionsGridFilter,
  endAuction,
  exportToPdfCarAuctionPDF,
} from 'data/auctions/Auctions.actions';

import { AuctionStatuses } from 'vdlib';
import ReduxHelper from 'lib/ReduxHelper';

const mapStateToProps = (state, ownProps) => {
  return ReduxHelper.mapStateWithLookups(
    {
      lang: state.i18n.locale,
      fetchingAuctions: state.auctions.fetchingForSelectionAuctions,
      filters: state.auctions.filters,
      auctions: state.auctions.forSelectionAuctions,
      submitting:
        state.auctions.cancellingAuctions === true ||
        state.auctions.endingAuction === true,
      auctionStatus: AuctionStatuses.ForSelection,
      user: state.app.user,
    },
    state,
    'fuelTypes',
    'vehicleTypes',
    'gearBoxes',
    'wheelDrives',
    'auctionStatuses',
    'regions',
    'partyTypes',
    'insurances',
    'bidFileTypes',
    'applications',
    'memberships',
    'cancellationReasons'
  );
};

const mapDispatchToProps = (dispatch, ownProps) => {
  return {
    endAuction: (bidId, ownerInfo) => dispatch(endAuction(bidId, ownerInfo)),
    setFilter: (name, value) => dispatch(setAuctionsGridFilter(name, value)),
    clearFilters: () => dispatch(clearAuctionsGridFilter()),
    fetchAuctions: skipStep => dispatch(fetchForSelectionAuctions(skipStep)),
    cancelAuction: auctionId => dispatch(cancelAuctions([auctionId])),
    cancelAuctionWithReason: (auctionId, reason) =>
      dispatch(cancelAuctions([auctionId], reason)),
    exportToPdfCarAuctionPDF: auctionID =>
      dispatch(exportToPdfCarAuctionPDF(auctionID)),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(AuctionsList);
